"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _OrderBookComponent = _interopRequireDefault(require("./OrderBookComponent"));
var _orderHistoryActions = require("../../redux/actions/orderHistoryActions");
var _numberFormatter = require("../../helpers/numberFormatter");
var _orderEntryActions = require("../../redux/actions/orderEntryActions");
var _level2Selectors = require("../../redux/selectors/level2Selectors");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _orderHistorySelectors = require("../../redux/selectors/orderHistorySelectors");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
var _SpreadRowComponent = _interopRequireDefault(require("./SpreadRowComponent"));
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var makeMapStateToProps = function makeMapStateToProps() {
  var openOrdersSelector = (0, _orderHistorySelectors.openOrdersSelectorFactory)();
  return function (state) {
    var _config$TradingLayout, _config$TradingLayout2;
    var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
    var selectedInstrumentId = selectedInstrument.InstrumentId;
    var fetching = state.apexCore.level2.fetching;
    var decimalPlaces = state.apexCore.product.decimalPlaces;
    var filter = {
      filterMode: 'selectedInstrument'
    };
    var level2 = (0, _level2Selectors.level2Selector)(state, filter);
    var openOrders = openOrdersSelector(state, filter);
    var buyOpenOrders = (0, _orderHistorySelectors.buyOpenOrdersSelector)(state, filter);
    var sellOpenOrders = (0, _orderHistorySelectors.sellOpenOrdersSelector)(state, filter);
    var spread = (0, _level2Selectors.spreadSelector)(state, filter);
    var convertedQuantityIncrement = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.QuantityIncrement);
    var convertedPriceIncrement = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement);
    return {
      level2: level2,
      spread: (0, _numberFormatter.formatNumberToLocale)(spread, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement)),
      decimalPlaces: decimalPlaces,
      fetching: fetching,
      selectedInstrumentId: selectedInstrumentId,
      openOrders: openOrders,
      buyOpenOrders: buyOpenOrders,
      sellOpenOrders: sellOpenOrders,
      selectedInstrument: selectedInstrument,
      convertedQuantityIncrement: convertedQuantityIncrement,
      convertedPriceIncrement: convertedPriceIncrement,
      SpreadComponent: _SpreadRowComponent["default"],
      showAccumulatedSum: (_config$TradingLayout = (_config$TradingLayout2 = _config["default"].TradingLayout) === null || _config$TradingLayout2 === void 0 ? void 0 : _config$TradingLayout2.showAccumulatedSum) !== null && _config$TradingLayout !== void 0 ? _config$TradingLayout : false
    };
  };
};
var mapDispatchToProps = {
  cancelAllOrders: _orderHistoryActions.cancelAllOrders,
  cancelBuyOrders: _orderHistoryActions.cancelBuyOrders,
  cancelSellOrders: _orderHistoryActions.cancelSellOrders,
  cancelOrders: _orderHistoryActions.cancelOrders,
  buyQuantityClicked: _orderEntryActions.buyQuantityClicked,
  buyPriceClicked: function buyPriceClicked(e) {
    return (0, _orderEntryActions.buyPriceClicked)(e.currentTarget.dataset.price);
  },
  sellQuantityClicked: _orderEntryActions.sellQuantityClicked,
  sellPriceClicked: function sellPriceClicked(e) {
    return (0, _orderEntryActions.sellPriceClicked)(e.currentTarget.dataset.price);
  }
};
var _default = exports["default"] = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_OrderBookComponent["default"]);